module.exports = {
    application: 'balus-local',
    token: '<invalid>',
    enabled: false
};



// WEBPACK FOOTER //
// ../etc/config/trackjs/localhost.js